var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"start"}},[_c('v-col',{staticClass:"col-12"},[_c('h1',[_vm._v("Zeitschriften")])])],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }